webpackJsonp([14822362812536],{

/***/ 408:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---brand-design-high-street-a0e39f21c11f6a62c5ab.js